var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 30",
    style: {
      enableBackground: "new 0 0 15 30"
    },
    xmlSpace: "preserve",
    width: 15,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,10V7c0-1.3,0.3-2,2.4-2H15V0h-4C6,0,4,3.3,4,7v3H0v5h4v15h6V15h4.4l0.6-5H10z"
  })));
};

export default SvgFacebook;